import { PatientIdentifier } from "@/types/patient/patientIdentifierConfig/patientIdentifierConfig";

export const formatPatientAddress = (address?: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return address?.replace(urlRegex, "").trim();
};

export const FACILITY_UHID_SYSTEM = "https://aayushnet.com/id/uhid";

export const isUhidIdentifier = (identifier: PatientIdentifier) => {
  return identifier.config.config.system === FACILITY_UHID_SYSTEM;
};

export const getFacilityUhidIdentifier = (
  facilityIdentifiers: PatientIdentifier[] = [],
) => {
  return facilityIdentifiers.find(isUhidIdentifier);
};

export const maskIdentifierValue = (value: string) => {
  if (value.length <= 4) {
    return value;
  }

  return `****${value.slice(-4)}`;
};

export const getDisplayIdentifierValue = (identifier: PatientIdentifier) => {
  return identifier.config.config.hide_id
    ? maskIdentifierValue(identifier.value)
    : identifier.value;
};

export const getDisplayIdentifiers = (
  instanceIdentifiers: PatientIdentifier[] = [],
  facilityIdentifiers: PatientIdentifier[] = [],
) => {
  const uhidIdentifier = getFacilityUhidIdentifier(facilityIdentifiers);

  return [
    ...(uhidIdentifier ? [uhidIdentifier] : []),
    ...instanceIdentifiers.filter(
      ({ config }) => !config.config.auto_maintained,
    ),
  ];
};

export const getIdentifiersWithUhidFirst = (
  instanceIdentifiers: PatientIdentifier[] = [],
  facilityIdentifiers: PatientIdentifier[] = [],
  predicate: (identifier: PatientIdentifier) => boolean = () => true,
) => {
  const uhidIdentifier = getFacilityUhidIdentifier(facilityIdentifiers);

  return [
    ...(uhidIdentifier ? [uhidIdentifier] : []),
    ...instanceIdentifiers.filter(predicate),
  ];
};
